import { Avatar, Box, Card, CardContent, Grid, LinearProgress, Typography } from '@mui/material';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';

export const LivelloCarburante = (props) => (
  <Card
    sx={{ height: '100%' }}
    {...props}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="overline"
          >
            Livello Carburante
          </Typography>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            {props.livelloCarburante?
            props.livelloCarburante.toFixed(2) +"%"
            :
            ""
          }
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: 'warning.main',
              height: 56,
              width: 56
            }}
          >
            <LocalGasStationIcon />
          </Avatar>
        </Grid>
      </Grid>
      <Box sx={{ pt: 3 }}>
        <LinearProgress
          value={props.livelloCarburante?
            props.livelloCarburante
            :
            0}
          variant="determinate"
          backgroundColor="red"
        />
      </Box>
    </CardContent>
  </Card>
);
